import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  QueryList,
  Renderer2,
  SimpleChanges,
  ViewChildren,
  ViewEncapsulation
} from '@angular/core';
import { FileFolders, TreeModel } from '../fascicolo/documentazione-allegata-view/documentazione-allegata.component';
import { DialogService } from 'src/app/core/components/dialog/dialog.service';
import { ConfirmModalComponent } from 'src/app/core/components/dialog/components/confirm-modal/confirm-modal.component';

@Component({
  selector: 'app-treeview-component',
  templateUrl: './treeview-component.component.html',
  styleUrls: ['./treeview-component.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class TreeviewComponentComponent implements OnInit, AfterViewInit, OnChanges {
  @ViewChildren('options') options: QueryList<ElementRef>;
  @ViewChildren('icons') iconsTags: QueryList<ElementRef>;
  @Input() showFileDetail: boolean;
  @Input() refreshData: boolean;
  @Input('treeModel') model: TreeModel = null;
  @Input() itemSelected: FileFolders;
  @Input() isFolder: boolean;
  @Output() onItemSelected: EventEmitter<any> = new EventEmitter<any>();
  @Output() setRefreshData = new EventEmitter();
  @Output() onClickMoveDocument = new EventEmitter();
  @Output() from = new EventEmitter();
  @Output() to = new EventEmitter();
  @Output() onUploadFileService = new EventEmitter();
  eleList: ElementRef[];
  eleMap: Map<string, ElementRef>;
  iconsMap: Map<string, ElementRef>;
  TREEVIEW_SUFFIX: string = '_treeView';
  ICON_SUFFIX:string = '_icon';
  ARIA_EXPANDED: string = 'aria-expanded';
  DATA_CHILDCOUNT = 'data-childcount';
  DATA_LID: string = 'data-lid';
  DATA_CODE: string = 'data-code';
  DATA_ISFIRST: string = 'data-first';
  DATA_ISLAST: string = 'data-last';
  TAB_INDEX: string = 'tabindex';
  currentActiveDescdentElement: string;

  public isDragAction: boolean;
  // public isDragOver: boolean;

  constructor(private renderer: Renderer2, private modal: DialogService) { }

  ngOnInit() {

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.itemSelected && !!this.itemSelected) {
      this.closeAllSection();
      this.toggleSelection(null, this.itemSelected);
    }
    if (changes.refreshData && !!this.refreshData) {
      if (changes.refreshData.previousValue !== undefined ) {
        setTimeout(() => {
          this.toggleSelection(null, this.itemSelected, true);
        }, 1000);
      }
      this.setRefreshData.emit(false);
    }
    /*if (changes.model && !!this.model) {
      this.createInitMap();
      this.eleList = this.options.toArray();
      this.setInitialActiveDescendent();
    }*/
  }

  ngAfterViewInit(): void {
    this.options.changes.subscribe(val => {
      if (this.model) {
        this.createInitEleMap();
        this.eleList = this.options.toArray();
        this.setInitialActiveDescendent();
      }
    });
    this.iconsTags.changes.subscribe(val => {
      if (this.model) {
        this.createInitIconMap();
        // this.eleList = this.options.toArray();
        // this.setInitialActiveDescendent();
      }
    });
  }

  setInitialActiveDescendent() {
    if (this.eleList != null && Array.isArray(this.eleList)) {
      this.currentActiveDescdentElement = this.eleList[0].nativeElement.id;
    }
  }

  createInitEleMap() {
    this.eleMap = new Map<string, ElementRef>();
    this.options.forEach((eleRef: ElementRef, index: number, optionsarray: ElementRef[]) => {
      this.renderer.setAttribute(eleRef.nativeElement, 'data-lid', String(index));
      this.eleMap.set(eleRef.nativeElement.id, eleRef);
    });
  }

  createInitIconMap() {
      this.iconsMap = new Map<string, ElementRef>();
      this.iconsTags.forEach((eleRef: ElementRef, index: number, optionsarray: ElementRef[]) => {
        this.iconsMap.set(eleRef.nativeElement.id, eleRef);
      });
  }

  setTabIndexOnLoad(role: string, i: number) {
    return (role == 'tree' && i == 0) ? '0' : '-1';
  }

  toggleSelectionEvent($event: any, item: any) {
    if (!this.itemSelected || item.code !== this.itemSelected.code) {
      this.onItemSelected.emit(item);
    } else {
      this.toggleSelection($event, item);
    }
  }

  toggleSelection($event: any, item: any, expanded = false) {
    // this.onItemSelected.emit(item);
    this.options.some((eleRef: ElementRef, index: number, optionsarray: ElementRef[]) => {
      const code = eleRef.nativeElement.getAttribute('data-code')
      if (!!item && code == item[this.model.cid]) {
        const isExpanded = eleRef.nativeElement.getAttribute(this.ARIA_EXPANDED);
        if (!expanded) {
          this.setElementAttribute(eleRef, this.ARIA_EXPANDED, (isExpanded == 'true') ? 'false' : 'true');
        } else {
          this.setElementAttribute(eleRef, this.ARIA_EXPANDED, 'true');
        }
        if (this.currentActiveDescdentElement != null) {
          const caliEleRef = this.eleMap.get(this.currentActiveDescdentElement);
          if (caliEleRef != null) {
            this.setElementAttribute(caliEleRef, this.TAB_INDEX, '-1');
            this.setElementAttribute(eleRef, this.TAB_INDEX, '0');
            this.currentActiveDescdentElement = eleRef.nativeElement.id;
          }
        }
        return true;
      }
    });
  }

  closeAllSection() {
    if (this.itemSelected.root) {
      this.options.forEach((eleRef: ElementRef) => {
        this.setElementAttribute(eleRef, this.ARIA_EXPANDED, 'false');
      });
    }
  }


  getExpandCollapseClass(item: any) {
    if (item != null && item.children != null && item.children.length > 0) {
      return 'glyphicon '+ this.model.iconExpand;
    }
    if (item.documento && (item.documento.refDocumentale || item.documento.missingFile)) {
      return 'glyphicon ' + this.model.iconNeutral;
    }
    if (!item.documento || (!item.documento.refDocumentale && !item.documento.missingFile)) {
      return 'glyphicon ' + this.model.iconExpand;
    }
    // return 'glyphicon ' + this.model.iconNeutral;
  }

  isChildrenExists(items: any[]) {
    return (items != null && items.length > 0) ? true : false;
  }

  filterList(list) {
    if (this.showFileDetail) {
      return list;
    } else {
      const newList = list.map(el => {
        if (el && ((el.children != null && el.children.length > 0) || ((!el.documento || (!el.documento.refDocumentale && !el.documento.numeroProtocollo && !el.documento.missingFile))))) {
          return el;
        }
      }).filter(Boolean);
      return newList;
    }
  }

  collapsedState(item: any) {
    if (item != null && item.children != null && item.children.length > 0) {
      item.ariaExpanded = 'false';
      return 'false';
    }
    return null;
  }

  // determines if the current node has children or not
  getChildCount(item: any) {
    if (item != null && item[this.model.cnid] != null) {
      const items = item[this.model.cnid];
      return (Array.isArray(items) ? items.length : 0);
    }
    return '0';
  }

  setElementAttribute(eleRef: ElementRef, attribute: string, value: string) {
    this.renderer.setAttribute(eleRef.nativeElement, attribute, value);
    const icon = eleRef.nativeElement.querySelector('i');
    const iconEleRef = this.iconsMap.get(icon.id);
    if (value == 'true') {
      this.renderer.removeClass(iconEleRef.nativeElement,this.model.iconExpand);
      this.renderer.addClass(iconEleRef.nativeElement,this.model.iconCollapse);
    } else if (value == 'false') {
      this.renderer.removeClass(iconEleRef.nativeElement,this.model.iconCollapse);
      this.renderer.addClass(iconEleRef.nativeElement,this.model.iconExpand);
    }
  }

  getTreeItemId(item: any, treeId: string) {
    return item[this.model.cid] + '_' + treeId + this.TREEVIEW_SUFFIX;
  }
  getIconId(item: any, treeId: string) {
    const itemId = this.getTreeItemId(item, treeId);
    return itemId + '_' + this.ICON_SUFFIX;
  }
  scrollIntoViewSmoothly(eleRef: ElementRef) {
    eleRef.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
  }
  setToFocus(eleRef: ElementRef) {
    this.currentActiveDescdentElement = eleRef.nativeElement.id;
    eleRef.nativeElement.focus();
    this.scrollIntoViewSmoothly(eleRef);
  }

  /*** DRAG & DROP ***/

  dragOver(ev, item) {
    console.log('dragOver', item);
    ev.preventDefault();
    ev.stopPropagation();
    this.options.forEach((eleRef: ElementRef) => {
      const code = eleRef.nativeElement.getAttribute('data-code');
      if (code == item[this.model.cid]) {
        this.renderer.addClass(eleRef.nativeElement, 'drag-over');
      } else {
        this.renderer.removeClass(eleRef.nativeElement, 'drag-over');
      }
    });
    // this.isDragOver = true;
    this.isDragAction = true;
  }

  dragStart(ev, item) {
    console.log('dragStart', item);
    // console.log('From: ', item);
    this.from.emit(item);
    ev.stopPropagation();
    this.options.forEach((eleRef: ElementRef) => {
      const code = eleRef.nativeElement.getAttribute('data-code');
      if (code == item[this.model.cid]) {
        this.renderer.addClass(eleRef.nativeElement, 'dragged');
      } else {
        this.renderer.removeClass(eleRef.nativeElement, 'dragged');
      }
    });
    // ev.dataTransfer.setData("text", ev.target.id);

  }

  drop(ev, item) {
    console.log("drop", item);
    if(this.isFolder === false) {
      // console.log('To: ', item);
      this.to.emit(item);
      // this.isDragAction = false;
      // this.isDragOver = false;
      ev.preventDefault();
      ev.stopPropagation();
      // const data = ev.dataTransfer.getData('text');
      // console.log(data);
      this.options.forEach((eleRef: ElementRef) => {
        this.renderer.removeClass(eleRef.nativeElement, 'drag-over');
      });
      // ev.target.appendChild(document.getElementById(data));
      const files = ev.dataTransfer.files;
      if (files.length > 0) {
        // Upload File
        this.onUploadFileService.emit(files);
      }
    } else {
      if(this.isDragAction) {
      this.modal.open(ConfirmModalComponent, {
        data: {
          style: { width: "50%" },
          modalConfirm: {
            text: 'Non è possibile spostare le cartelle',
            data: [],
            hideButtons: true,
            confirmButton: true
          },
          title: 'Attenzione',
        }
      });
      }
      this.isDragAction = false;
    }
  }


  /*** EXECUTE KEY ***/

  executeKeydown($event) {
    const keyCode = $event.which;
  }
}
